module.exports = __webpack_public_path__ + "static/media/sleep.c0e0b3ac.svg";